import {
  DocumentNode,
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
  TypedDocumentNode,
  useMutation,
} from '@apollo/client'
import useJamesApolloError from './useJamesApolloError'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useJamesApolloMutation = <TData = any, TVariables extends OperationVariables = OperationVariables>(
  mutationQuery: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: MutationHookOptions<TData, TVariables>,
): MutationTuple<TData, TVariables> => {
  const onError = useJamesApolloError()

  return useMutation(mutationQuery, {
    ...options,
    onError,
  })
}

export default useJamesApolloMutation
